"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nav = exports.Header = void 0;
var Header_1 = require("./Header/Header");
Object.defineProperty(exports, "Header", { enumerable: true, get: function () { return __importDefault(Header_1).default; } });
var Nav_1 = require("./Nav/Nav");
Object.defineProperty(exports, "Nav", { enumerable: true, get: function () { return __importDefault(Nav_1).default; } });
